<script>
  import { dayjs } from "svelte-time";
  import { fade } from "svelte/transition";
  import BookingQuantitySummary from "./BookingQuantitySummary.svelte";
  import { createEventDispatcher } from "svelte";
  import BackButton from "./BackButton.svelte";
  import { currentLanguage } from "../../store";
  import translations from "../../translations";
  import { onMount } from "svelte";

  const dispatch = createEventDispatcher();

  export let dateHeading;
  export let data;
  export let dayStore;
  export let bookingConfig;
  export let quantity;
  export let showQuantitySummary = true;
  export let initialTime = null;

  let selectedItem = -1;
  let arrivalTime = "";
  let currentLang = navigator.language.split("-")[0] || "en";

  currentLanguage.subscribe((language) => {
    currentLang = language;
  });

  const handleSelect = (index) => {
    selectedItem = index;
    arrivalTime = bookingConfig?.capacityEnabled === true ? buildArrivalTimes(dayStore[index]?.time)[0]?.value || "" : "";
  };

  onMount(() => {
    if (!initialTime) return;
    const normalized = String(initialTime).slice(0, 5);
    const index = dayStore.findIndex((item) => {
      const match = String(item?.time || "").match(/T(\d{2}:\d{2})/);
      return match?.[1] === normalized;
    });
    if (index >= 0) {
      handleSelect(index);
      handleConfirm(index);
    }
  });
  const handleConfirm = (index) => {
    if (bookingConfig?.capacityEnabled === true) {
      if (arrivalTime) dispatch("confirm", { index, arrivalTime });
      return;
    }
    dispatch("confirm", index);
  };

  const formatArrivalTime = (date) =>
    new Intl.DateTimeFormat(navigator.language || "en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: bookingConfig?.use24HourTimeFormat !== true,
    }).format(date);

  const buildArrivalTimes = (timeRange) => {
    const start = new Date(timeRange?.substr(0, 25));
    const end = new Date(timeRange?.substr(26));
    const options = [];

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return options;

    for (let current = new Date(start); current < end; current = new Date(current.getTime() + 15 * 60 * 1000)) {
      options.push({ value: current.toISOString(), label: formatArrivalTime(current) });
    }
    return options;
  };

  const getStartTime = (str) => {
    if (bookingConfig.use24HourTimeFormat) {
      return dayjs(str.substr(0, 25)).format("HH:mm");
    } else {
      return dayjs(str.substr(0, 25)).format("hh:mm");
    }
  };

  const getStartTimeNoon = (str) => {
    if (bookingConfig.use24HourTimeFormat) {
      return "";
    } else {
      return dayjs(str.substr(0, 25)).format(" A");
    }  
  };

  const getCapacityLabel = (item) => {
    const start = dayjs(item.time.substr(0, 25)).format("HH:mm");
    const end = dayjs(item.time.substr(26)).format("HH:mm");
    const name = typeof item.name === "string" ? item.name.trim() : "";
    const range = `${start} a ${end}`;

    return name ? `${name} (${range})` : range;
  };
</script>

<div class="chatwith-booking-scheduler" transition:fade={{ duration: 125 }}>
  {#if showQuantitySummary && quantity !== undefined}
    <BookingQuantitySummary {quantity} label={bookingConfig?.attendeesLabel} on:change={() => dispatch("changeQuantity")} />
  {/if}
  <div class="chatwith-booking-back" on:click={() => dispatch("back")}>
    <BackButton />
  </div>

  <div class="chatwith-booking-scheduler-heading">{dateHeading}</div>
  <div class="chatwith-booking-scheduler-title">
    <!-- {data.translateSelectDateAndField ?? "Select a time"} -->
  </div>
  <div class="chatwith-booking-times">
    {#each dayStore as item, i}
      {#if selectedItem === i}
        <div class:chatwith-booking-time-wrapper-capacity={bookingConfig?.capacityEnabled === true} class="chatwith-booking-time-wrapper">
          <div class="chatwith-booking-time-selected" on:click={() => handleSelect(i)}>
            {#if bookingConfig?.capacityEnabled === true}
              <div>{getCapacityLabel(item)}</div>
            {:else}
              <div>{getStartTime(item.time)}<b>{getStartTimeNoon(item.time)}</b></div>
            {/if}
          </div>
          {#if bookingConfig?.capacityEnabled === true}
            <div class="chatwith-booking-arrival-inline">
              <label for={`chatwith-arrival-${i}`}>
                {translations.arrivalTime[currentLang] || translations.arrivalTime.en}
              </label>
              <select id={`chatwith-arrival-${i}`} bind:value={arrivalTime}>
                {#each buildArrivalTimes(item.time) as option}
                  <option value={option.value}>{option.label}</option>
                {/each}
              </select>
              <button type="button" disabled={!arrivalTime} on:click={() => handleConfirm(i)}>
                <span>{translations.continue[currentLang] || translations.continue.en}</span>
                <span class="chatwith-booking-continue-arrow" aria-hidden="true">→</span>
              </button>
            </div>
          {:else}
            <div class="chatwith-booking-time-confirm" on:click={() => handleConfirm(i)}>
              {data.translateConfirm ?? "Confirm"}
            </div>
          {/if}
        </div>
      {:else}
        <div class="chatwith-booking-time" on:click={() => handleSelect(i)}>
          {#if bookingConfig?.capacityEnabled === true}
            <div>{getCapacityLabel(item)}</div>
          {:else}
            <div>{getStartTime(item.time)}<b>{getStartTimeNoon(item.time)}</b></div>
          {/if}
        </div>
      {/if}
    {/each}
  </div>
  {#if dayStore.length > 0}
    <div class="chatwith-booking-gmt">{`GMT + ${dayStore[0].time.substr(20, 5)}`}</div>
  {/if}
</div>
